module.exports = "./img/1e42a2fe4b2154e2d71a0d1f09890ba9.png";